import React from 'react';
import { useAuth } from '../context/AuthContext';
import authService from '../services/authService';

const AuthDebug = () => {
  const { currentUser } = useAuth();
  const localStorageUser = authService.getCurrentUser();

  return (
    <div className="container mt-4">
      <div className="card">
        <div className="card-header">
          <h5>Authentication Debug Information</h5>
        </div>
        <div className="card-body">
          <h6>Current User from Context:</h6>
          <pre className="bg-light p-2">
            {JSON.stringify(currentUser, null, 2)}
          </pre>
          
          <h6>User from Local Storage:</h6>
          <pre className="bg-light p-2">
            {JSON.stringify(localStorageUser, null, 2)}
          </pre>
          
          <h6>Admin Check Results:</h6>
          <ul>
            <li>
              <strong>Context User Exists:</strong> {currentUser ? 'Yes' : 'No'}
            </li>
            <li>
              <strong>Context User Roles:</strong> {currentUser?.roles ? currentUser.roles.join(', ') : 'None'}
            </li>
            <li>
              <strong>Is Admin (Context):</strong> {
                currentUser && currentUser.roles && 
                currentUser.roles.some(role => role === 'ROLE_ADMIN') ? 'Yes' : 'No'
              }
            </li>
            <li>
              <strong>LocalStorage User Exists:</strong> {localStorageUser ? 'Yes' : 'No'}
            </li>
            <li>
              <strong>LocalStorage User Roles:</strong> {localStorageUser?.roles ? localStorageUser.roles.join(', ') : 'None'}
            </li>
            <li>
              <strong>Is Admin (LocalStorage):</strong> {
                localStorageUser && localStorageUser.roles && 
                localStorageUser.roles.some(role => role === 'ROLE_ADMIN') ? 'Yes' : 'No'
              }
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default AuthDebug;